import type { ResponsesProps } from '@consta/uikit/Responses'
import type { FC } from 'react'

import css from './Responses.css'

export const createResponse = (ResponseComponent: FC<Omit<ResponsesProps, 'image'>>) => {
  const Wrapper: FC<Pick<ResponsesProps, 'description' | 'size'>> = ({ description, size }) => {
    return (
      <div className={css.container}>
        <ResponseComponent className={css.response} size={size} description={description} />
      </div>
    )
  }

  Wrapper.displayName = ResponseComponent.displayName
  return Wrapper
}
